import { RsoEditPage } from "@/features/rso/pages/RsoEdit";
import React from "react";

const RsoEdit = () => {
  return <RsoEditPage />;
};

export default RsoEdit;
